import React from "react";
import Layout from "../components/Layout";
import MintedSales from "../components/_MintedSales";

const MintedSalesPage = (props:any) => {
    return (
    <Layout>
        <MintedSales />
    </Layout>
    )
}

export default MintedSalesPage